/** Fogarty order-summary actions, matching production order-buttons. */
import CartPanel from "../../../components/base/CartPanel.js";
import { emit } from "../../../core/state.js";

export default class FogartyCartPanel extends CartPanel {
  get showBottleDepositTotal() {
    return false;
  }

  _renderActions() {
    const footer = document.createElement("div");
    footer.className = "ws-cart-actions";
    for (const [label, event] of [
      ["View cart", "ws-cart-open"],
      ["Proceed to checkout", "ws-checkout"],
    ]) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "ws-cart-action-btn";
      button.textContent = label;
      button.addEventListener("click", () => {
        button.classList.add("is-selected");
        emit(event);
      });
      footer.appendChild(button);
    }
    return footer;
  }
}
